<template>
  <action-dispatcher
    action="product/getProduct"
    :parameters="$route.params.id"
    @success="loaded"
    class="view-product-upsell"
  >
    <step-title title="Configure sua área de membros" />

    <div class="d-flex align-items-center">
      <b-form-checkbox
        id="is-blitz-members"
        v-model="isBlitzMembers"
        switch
        :disabled="!subdomain"
      >
        Ativar área de membros
      </b-form-checkbox>
      <bp-tooltip
        v-if="!subdomain"
        text="Cadastre um subdomínio para ativar sua área de membros"
      >
        <span class="danger-info-circle ml-3 mb-lg-3">!</span>
      </bp-tooltip>
    </div>

    <action-dispatcher action="membersSetup/get" :parameters="$route.params.id">
      <setup :setup="setup" />
    </action-dispatcher>
  </action-dispatcher>
</template>

<script>
import { BpTooltip } from "@/components/designSystem/";
import Setup from "@/components/product/details/content/Setup";
import MemberAreaMixin from "@/mixins/memberArea.js";
import { mapState } from "vuex";

export default {
  components: { Setup, BpTooltip },
  mixins: [MemberAreaMixin],
  data() {
    return {
      isBlitzMembers: false
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersSetup", ["setup"]),
    subdomain() {
      return this.setup?.subdomain;
    },
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        { title: "Configurar área de membros" }
      ];
    }
  },
  watch: {
    isBlitzMembers(v) {
      this.$store
        .dispatch("product/put", {
          id: this.$route.params.id,
          is_blitz_members: v
        })
        .then(({ data }) => this.$store.commit("product/setProduct", data));
    }
  },
  methods: {
    loaded() {
      this.isBlitzMembers = this.product.is_blitz_members;
    }
  }
};
</script>
<style lang="scss" scoped>
.view-product-upsell {
}
</style>
